export const testTypeAB = 1;
export const testTypeBidding = 2;
export const testTypeQuick = 3;
